<div class="container">
    <div class="container-row">
        <div class="back-button-container">
            <button (click)="goBackOnce()">back</button>
        </div>
        <div class="container">
            <h1>Fare Update</h1>
        </div>
    </div>

    <!-- Develop this div appropriately -->
    <div class="container">
        <div class="fareupdation-banner">
            <figure>
                <a href="https://www.newgenapps.com/wp-content/uploads/2020/04/Navigator-Navigation-Google-Maps-Map-Location-Gps-2049643.jpg"
                    target="_blank">
                    <img id="t-img" alt="Fare Updation" src="assets/images/capture.png" width="304" height="328">
                </a>
            </figure>
        </div>
    </div>
    <div *ngIf="!submitted">
        <form action="/action_page.php">
            <div>
                <label for="bus_type"><br><b>Enter Bus Type</b> </label><br>
                <select [(ngModel)]="document.bus_type">
                    <option [ngValue]="null" disabled>Choose Bus Type </option>
                    <option [ngValue]="null">Select Bus Type </option>
                    <option *ngFor="let type of busTypes" type="text" id="new_name" name="new_name">
                        {{type}}
                    </option>
                </select>
                <div *ngIf="!this.validators[0]">
                    <span id="validator">Enter Bus type</span>
                </div>
            </div>
            <div>
                <label for="minprice"><br><b>Revised minimum price</b> (in Rupees)</label><br>
                <input type="number" id="Bnum" name="Bnum" required [(ngModel)]="document.min_price">
                <div *ngIf="!this.validators[1]">
                    <span id="validator">Enter minimum price</span>
                </div>
            </div>
            <div>
                <label for="price/km"><br><b>Price/KM </b>(in Rupees)</label><br>
                <input type="number" id="from" name="from" required [(ngModel)]="document.per_km">
                <div *ngIf="!this.validators[2]">
                    <span id="validator">Enter price per km</span>
                </div>
            </div>
            <br>
            <div>
                <input type="submit" value="Update" (click)="saveFare()">
            </div>
        </form>
    </div>
    <div *ngIf="submitted">
        <h4>You updated fare successfully!</h4>
        <button (click)="newFare()">Back</button>
    </div>
</div>